import { Card, CardBody, Col } from "reactstrap";
import CardHeaderCommon from "../../../../../CommonElements/CommonCardHeader/CardHeaderCommon";
import { TimeLineHeading } from "../../../../../utils/Constant";
import { onlineTimelineGroup, onlineTimelineItems } from "../../../../../Data/Dashboard/Ecommerce/Ecommerce";
import Timeline from "react-calendar-timeline";

const WidgetTimeLine = () => {
  return (
    <Col xl="6" lg="6">
      <Card>
        <CardHeaderCommon title={TimeLineHeading} />
        <CardBody className="pt-0">
          <div className="overflow-auto theme-scrollbar custom-scrollbar">
            <div className="timeline-calendar custom-scrollbar">
              <div className="custom-calendar general-Widgets" id="calendar-container">
                <div className="time-line custom-scrollbar" id="calendar">
                  <Timeline groups={onlineTimelineGroup} items={onlineTimelineItems} defaultTimeStart={new Date().getTime()} defaultTimeEnd={new Date().setHours(new Date().getHours() + 4)} />
                </div>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default WidgetTimeLine;
